
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserDetails"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesforceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oktaId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"portfolioId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modalOff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schoolId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"districtId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"witsbyContractGroupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"witsbyRole"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"witsbySubscriberStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"welcomeEmailDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subjectAreas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schoolName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recoveryEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryAccountName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryAccountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personalPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"grades"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"districtName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minutesPerWeek"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initialYearOfService"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardFilter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chat"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockedUsers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"blockedByUsers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notificationPreferences"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailNotification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"soundNotification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"messageBadge"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastActiveConversation"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":797}};
    doc.loc.source = {"body":"fragment UserDetailsFragment on UserDetails {\n  _id\n  salesforceId\n  oktaId\n  portfolioId\n  name\n  firstName\n  lastName\n  title\n  email\n  avatarUrl\n  modalOff\n  schoolId\n  districtId\n  witsbyContractGroupId\n  witsbyRole\n  witsbySubscriberStatus\n  welcomeEmailDate\n  subscriptionType\n  subjectAreas\n  schoolName\n  recoveryEmail\n  primaryAccountName\n  primaryAccountId\n  personalPhone\n  organizationType\n  jobType\n  grades\n  districtName\n  minutesPerWeek\n  initialYearOfService\n  organization {\n    id\n    name\n  }\n  preferences {\n    dashboardFilter\n    chat {\n      blockedUsers\n      blockedByUsers\n      notificationPreferences {\n        emailNotification\n        soundNotification\n        messageBadge\n      }\n      lastActiveAt\n      lastActiveConversation\n    }\n  }\n  createdAt\n  updatedAt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UserDetailsFragment"] = oneQuery(doc, "UserDetailsFragment");
        
